import { Routes, Route, Navigate, Outlet, useNavigate } from "react-router-dom";
import OrganisationLoginPage from "./pages/auth/login";
import "./App.css";
import Users from "./pages/add-users";
import "primereact/resources/themes/lara-light-teal/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css"; //icons
import OrganisationDashboard from "./pages/dashboard/index";
import AddCustomer from "./pages/dashboard/booking/AddCustomer";
import CompleteBooking from "./pages/dashboard/booking/CompleteBooking";
import { GET_USER_TOKEN, validateToken } from "./utils/helper";
import PriceList from "./pages/dashboard/ProductPriceList";
import ForgotPasswordPage from "./pages/auth/forgot-password";
import ResetPasswordPage from "./pages/auth/reset-password";
import CustomersList from "./pages/customers";
import CustomerDetailsIndex from "./pages/customers/id";
import AppointmentDetails from "./pages/dashboard/booking/AppointmentDetails";
import OrderDetailsPage from "./pages/orders/OrderDetails";
import OldResultsPage from "./pages/old-results";
import OrdersList from "./pages/orders";
import AddNewBookerAccount from "./pages/customers/add-customer";
import { useEffect } from "react";
import { isToken } from "typescript";
import { emptyLocalStorage, emptySessionStorage } from "./utils/browserStorage";
import { resetNewBookingData } from "./store/slices/organisation";
import { useAppDispatch } from "./store";

const token = GET_USER_TOKEN();
export const ProtectedRoute = ({ children }: any) => {
  if (!token) {
    // user is not authenticated
    return <Navigate to="/" />;
  }
  return children;
};

//import "primeflex/primeflex.css";
function App() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const isTokenExpired = validateToken(token as string);
    if (isTokenExpired) {
      emptySessionStorage();
      emptyLocalStorage();
      dispatch(resetNewBookingData());
      navigate("/login");
    }
  }, [token]);
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="login" element={<OrganisationLoginPage />} />
      <Route
        path="dashboard"
        element={
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        }
      >
        <Route path="" element={<OrganisationDashboard />} />
        <Route path="booking/add-customer" element={<AddCustomer />} />
        <Route
          path="booking/appointment-details"
          element={<AppointmentDetails />}
        />
        <Route path="booking/complete-booking" element={<CompleteBooking />} />
        <Route path="price-list" element={<PriceList />} />
        <Route path="customers" element={<CustomersList />} />

        <Route
          path="customers/:customerId"
          element={<CustomerDetailsIndex />}
        />
        <Route
          path="customers/add-new-booker-account"
          element={<AddNewBookerAccount />}
        />
        <Route path="users" element={<Users />} />
        <Route path="orders" element={<OrdersList />} />
        <Route path="orders/:orderId" element={<OrderDetailsPage />} />
        <Route path="old-results" element={<OldResultsPage />} />
      </Route>
      <Route path="reset-password" element={<ResetPasswordPage />} />
      <Route path="forgot-password" element={<ForgotPasswordPage />} />

      {/* <Route path="register" element={<Register />} />
                <Route path="reset-sent" element={<ResetCodeSent />} />
                <Route path="reset-password" element={<ResetPassword />} />
                <Route path="forgotPassword" element={<ForgetPassword />} />
                <Route path="reset-code" element={<ResetCodeSent />} />
                <Route path="forgot-password" element={<ForgetPassword />} /> */}
    </Routes>
  );
}

export default App;
